const GET_PRIMARY_APPROVER = 'GET_PRIMARY_APPROVER';
const SET_PRIMARY_APPROVER = 'SET_PRIMARY_APPROVER';

export {
    GET_PRIMARY_APPROVER,
    SET_PRIMARY_APPROVER
};